import React from "react";
import { deleteProperty, deleteUser } from "../../utils/api";

function DeleteConfirmModal({
  show,
  onClose,
  propertyId,
  userId,
  refresh,
  setBanner,
}) {
  if (!show) return null;

  const handleDelete = async () => {
    try {
      if (propertyId) {
        await deleteProperty(propertyId);
        setBanner({
          type: "warning",
          message: "Property deleted successfully.",
        });
      }
      if (userId) {
        await deleteUser(userId);
        setBanner({ type: "warning", message: "User deleted successfully." });
      }
      refresh();
      onClose();
    } catch (err) {
      setBanner({
        type: "danger",
        message: "Delete failed. Please try again.",
      });
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">Confirm Delete</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <p>
              Are you sure you want to delete{" "}
              {propertyId ? "this property" : "this user"}? This action cannot
              be undone.
            </p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-danger" onClick={handleDelete}>
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmModal;
